import type { PropsWithChildren } from "react";
import { useCallback, useState } from "react";

import { CreateModuleSettingsContext, type Metadata } from "./CreateModuleSettingsContext";

const defaultMetadata: Metadata = {
  title: "",
  defaultLanguage: "en",
  learnerExperience: [],
  audience: [],
  intent: [],
  tags: [],
  version: "0.0.1-0",
  readonly: false,
  thumbnailAssetId: null,
};

export const CreateModuleSettingsProvider = ({ children }: PropsWithChildren) => {
  const [metadata, setMetadata] = useState<Metadata>(defaultMetadata);

  const [utilizeAi, setUtilizeAi] = useState(false);
  const [adaptToAudience, setAdaptToAudience] = useState(false);
  const [understood, setUnderstood] = useState(false);

  const updateMetadata = useCallback(
    (data: Partial<Metadata>) => setMetadata((current) => ({ ...current, ...data })),
    [],
  );

  const reset = useCallback(() => {
    setMetadata(defaultMetadata);
    setUtilizeAi(false);
    setAdaptToAudience(false);
    setUnderstood(false);
  }, []);

  return (
    <CreateModuleSettingsContext.Provider
      value={{
        metadata,
        updateMetadata,
        utilizeAi,
        setUtilizeAi,
        adaptToAudience,
        setAdaptToAudience,
        understood,
        setUnderstood,
        reset,
      }}
    >
      {children}
    </CreateModuleSettingsContext.Provider>
  );
};
